"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityTrackingSet = void 0;
var Utils_1 = require("./Utils");
/**
 * Class to hold a collection of Activity Tracking Data
 */
var ActivityTrackingSet = /** @class */function () {
  function ActivityTrackingSet(isOrdered, list) {
    this.isOrdered = isOrdered;
    this.list = list;
  }
  ActivityTrackingSet.prototype.getIsOrdered = function () {
    return this.isOrdered;
  };
  ActivityTrackingSet.prototype.getList = function () {
    return this.list;
  };
  // returns a stringified json with the list and isOrdered info.
  ActivityTrackingSet.prototype.getActivityTrackingInfo = function (activityListener, surveyId) {
    var activitiesInfoObject;
    if (this.list.length === 0) {
      activitiesInfoObject = {
        Activities: [],
        IsListOrdered: this.isOrdered
      };
      return JSON.stringify(activitiesInfoObject);
    }
    for (var _i = 0, _a = this.list; _i < _a.length; _i++) {
      var trackingData = _a[_i];
      var actualCount = activityListener.getCount(trackingData.getActivity(), surveyId);
      var tempActivities = {
        Activity: trackingData.getActivity(),
        ActualCount: actualCount,
        Count: trackingData.getCount(),
        IsAggregate: trackingData.getIsAggregate(),
        IsDiscrete: actualCount % 1 === 0
      };
      if (Utils_1.isNOU(activitiesInfoObject)) {
        activitiesInfoObject = {
          Activities: [tempActivities],
          IsListOrdered: this.isOrdered
        };
      } else {
        activitiesInfoObject.Activities.push(tempActivities);
      }
    }
    return JSON.stringify(activitiesInfoObject);
  };
  return ActivityTrackingSet;
}();
exports.ActivityTrackingSet = ActivityTrackingSet;